module.exports = __webpack_public_path__ + "media/images/tl/banner/vi-dark-e83066797e64dd978186210f5327c949.jpg";